class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = Number.parseInt(
            this.getAttribute('data-delay'),
            10
        ) || 5000;

        this.expiresDate = Number.parseInt(
            this.getAttribute('data-expire'),
            10
        ) || 1;

        this.showTimer = null;
        this.imageTimer = null;
        this.hideTimer = null;
        this.initialized = false;

        this.handleBodyClick = this.onBodyClickEvent.bind(this);
        this.handleClose = this.setClosePopup.bind(this);
    }

    connectedCallback() {
        // Never let the newsletter popup hijack the Shopify theme editor.
        if (window.Shopify && Shopify.designMode) {
            document.body.classList.remove(
                'newsletter-show',
                'show-newsletter-image'
            );

            return;
        }

        if (this.initialized) {
            return;
        }

        this.initialized = true;

        this.closeButton = this.querySelector(
            '[data-close-newsletter-popup]'
        );

        this.contactForm = this.querySelector('#ContactPopup');

        document.body.addEventListener(
            'click',
            this.handleBodyClick
        );

        if (this.closeButton) {
            this.closeButton.addEventListener(
                'click',
                this.handleClose
            );
        }

        if (this.contactForm) {
            this.contactForm.addEventListener(
                'submit',
                this.handleClose
            );
        }

        if (this.getCookie('newsletter-popup') === '') {
            this.schedulePopup();
        }
    }

    disconnectedCallback() {
        this.clearTimers();

        document.body.removeEventListener(
            'click',
            this.handleBodyClick
        );

        if (this.closeButton) {
            this.closeButton.removeEventListener(
                'click',
                this.handleClose
            );
        }

        if (this.contactForm) {
            this.contactForm.removeEventListener(
                'submit',
                this.handleClose
            );
        }

        this.initialized = false;
    }

    schedulePopup() {
        this.clearTimers();

        this.showTimer = window.setTimeout(() => {
            if (
                !this.isConnected ||
                this.getCookie('newsletter-popup') !== ''
            ) {
                return;
            }

            document.body.classList.add('newsletter-show');

            this.imageTimer = window.setTimeout(() => {
                if (
                    this.isConnected &&
                    document.body.classList.contains('newsletter-show')
                ) {
                    document.body.classList.add(
                        'show-newsletter-image'
                    );
                }
            }, 700);

        }, this.timeToShow);
    }

    clearTimers() {
        window.clearTimeout(this.showTimer);
        window.clearTimeout(this.imageTimer);
        window.clearTimeout(this.hideTimer);

        this.showTimer = null;
        this.imageTimer = null;
        this.hideTimer = null;
    }

    setCookie(name, value, days) {
        const expiry = new Date();

        expiry.setTime(
            expiry.getTime() + days * 24 * 60 * 60 * 1000
        );

        document.cookie = [
            `${name}=${value}`,
            `expires=${expiry.toUTCString()}`,
            'path=/',
            'SameSite=Lax'
        ].join('; ');
    }

    getCookie(name) {
        const prefix = `${name}=`;

        for (const cookie of document.cookie.split(';')) {
            const trimmedCookie = cookie.trim();

            if (trimmedCookie.startsWith(prefix)) {
                return trimmedCookie.substring(prefix.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = [
            `${name}=`,
            'expires=Thu, 01 Jan 1970 00:00:01 GMT',
            'path=/',
            'SameSite=Lax'
        ].join('; ');
    }

    setClosePopup() {
        this.clearTimers();

        this.setCookie(
            'newsletter-popup',
            'closed',
            this.expiresDate
        );

        document.body.classList.remove('newsletter-show');

        this.hideTimer = window.setTimeout(() => {
            document.body.classList.remove(
                'show-newsletter-image'
            );
        }, 700);
    }

    onBodyClickEvent(event) {
        if (
            !document.body.classList.contains('newsletter-show') ||
            this.contains(event.target)
        ) {
            return;
        }

        const clickedOpener =
            event.target instanceof Element &&
            event.target.closest('[data-open-newsletter-popup]');

        if (!clickedOpener) {
            this.setClosePopup();
        }
    }
}

if (!customElements.get('newsletter-popup')) {
    customElements.define(
        'newsletter-popup',
        NewsletterPopup
    );
}

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.initialized = false;

        this.handleClose = this.close.bind(this);
        this.handleBodyClick = this.onBodyClickEvent.bind(this);
    }

    connectedCallback() {
        if (window.Shopify && Shopify.designMode) {
            document.body.classList.remove(
                'newsletter-message-show'
            );

            return;
        }

        if (this.initialized) {
            return;
        }

        this.initialized = true;

        this.closeButton = this.querySelector(
            '[data-close-newsletter-message-popup]'
        );

        if (this.closeButton) {
            this.closeButton.addEventListener(
                'click',
                this.handleClose
            );
        }

        document.body.addEventListener(
            'click',
            this.handleBodyClick
        );
    }

    disconnectedCallback() {
        if (this.closeButton) {
            this.closeButton.removeEventListener(
                'click',
                this.handleClose
            );
        }

        document.body.removeEventListener(
            'click',
            this.handleBodyClick
        );

        this.initialized = false;
    }

    close() {
        document.body.classList.remove(
            'newsletter-message-show'
        );
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }
}

if (!customElements.get('newsletter-message-popup')) {
    customElements.define(
        'newsletter-message-popup',
        NewsletterMessagePopup
    );
}